import { render, staticRenderFns } from "./ItemElementStatus.vue?vue&type=template&id=038dab86&scoped=true"
import script from "./ItemElementStatus.vue?vue&type=script&lang=ts"
export * from "./ItemElementStatus.vue?vue&type=script&lang=ts"
import style0 from "./ItemElementStatus.vue?vue&type=style&index=0&id=038dab86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038dab86",
  null
  
)

export default component.exports